var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5515 19.9265C11.5515 19.9265 9.92651 19.9265 9.92651 18.3015C9.92651 16.6765 11.5515 11.8015 18.0515 11.8015C24.5515 11.8015 26.1765 16.6765 26.1765 18.3015C26.1765 19.9265 24.5515 19.9265 24.5515 19.9265H11.5515ZM18.0515 10.1765C19.3444 10.1765 20.5844 9.66287 21.4987 8.74863C22.4129 7.83439 22.9265 6.59441 22.9265 5.30148C22.9265 4.00855 22.4129 2.76858 21.4987 1.85434C20.5844 0.940098 19.3444 0.426483 18.0515 0.426483C16.7586 0.426483 15.5186 0.940098 14.6044 1.85434C13.6901 2.76858 13.1765 4.00855 13.1765 5.30148C13.1765 6.59441 13.6901 7.83439 14.6044 8.74863C15.5186 9.66287 16.7586 10.1765 18.0515 10.1765Z",
    fill: "#1B3757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65251 19.9265C8.41162 19.4192 8.29148 18.863 8.30151 18.3015C8.30151 16.0996 9.40651 13.8327 11.4475 12.2565C10.4288 11.9426 9.36743 11.7891 8.30151 11.8015C1.80151 11.8015 0.176514 16.6765 0.176514 18.3015C0.176514 19.9265 1.80151 19.9265 1.80151 19.9265H8.65251Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48901 10.1765C8.56646 10.1765 9.59977 9.74847 10.3616 8.9866C11.1235 8.22474 11.5515 7.19143 11.5515 6.11398C11.5515 5.03654 11.1235 4.00323 10.3616 3.24136C9.59977 2.4795 8.56646 2.05148 7.48901 2.05148C6.41157 2.05148 5.37826 2.4795 4.61639 3.24136C3.85453 4.00323 3.42651 5.03654 3.42651 6.11398C3.42651 7.19143 3.85453 8.22474 4.61639 8.9866C5.37826 9.74847 6.41157 10.1765 7.48901 10.1765Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeicon);
export default __webpack_public_path__ + "static/media/employeeicon.0350bc0f8bb6c76272c2833c86b501be.svg";
export { ForwardRef as ReactComponent };